/* eslint-disable */
<template>
  <div id="instructor-snapshot-container" >
    <h1>Snapshot</h1>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'instructor-snapshot-container',
  components: {
  },
  data() {
    return {
    };
  },
  computed: mapGetters( 'instructor', [
  ]),
  methods:{
  ...mapActions([
  ]),

  },
  watch: {
  },
  mounted() {
  }
};
</script>

<style scoped>
#instructor-snapshot-container {
  width: calc(100vw -250px);
  height: 82vh;
  overflow: auto;
  min-width: 900px;
}
</style>
